export const filter = {
  search: "",
  status: "",
  service: "",
  assignee: "",
  created_by: "",
  turbine: "",
  sort: "",
  sideload: "",
};

export const pagination = {
  per_page: "",
  page: "",
};

export const ticketFilter = {
  search: "",
  status: "",
  service: "",
  assignees: "",
  coordinators: "",
  managers: "",
  created_by: "",
  turbine: "",
  client: "",
  project: "",
  report_done: "",
  sort: "",
  sideload: "",
};

export const clientFilter = {
  search: "",
  legal_name: "",
  tax_id: "",
  sort: "",
};

export const turbineFilter = {
  search: "",
  client: "",
  serial_number: "",
  location: "",
  sort: "",
};

export const locationFilter = {
  search: "",
  sort: "",
};

export const userManagementFilter = {
  search: "",
  is_active: "",
  email: "",
  groups__name: "",
  technician_level: "",
  sort: "",
};

export const materialsFilter = {
  search: "",
  category: "",
};

export const projectFilter = {
  search: "",
  project_status: "",
  name: "",
  client: "",
  sort: "",
};

export const servicesFilter = {
  search: "",
};
